import { render, staticRenderFns } from "./memberUnitsDetail.vue?vue&type=template&id=594e9b94&scoped=true&"
import script from "./memberUnitsDetail.vue?vue&type=script&lang=js&"
export * from "./memberUnitsDetail.vue?vue&type=script&lang=js&"
import style0 from "./memberUnitsDetail.vue?vue&type=style&index=0&id=594e9b94&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594e9b94",
  null
  
)

export default component.exports